export default {
  AMAP_READY_EVENT: 'AMAP_READY_EVENT',
  AMAP_LAYER_READY_EVENT: 'AMAP_LAYER_READY_EVENT'
};



// WEBPACK FOOTER //
// ./src/lib/utils/constant.js